const DOCTOR_IMAGE_BASE = '/wp-content/themes/jw-zw/assets/images/doctor/';
const HOSPITAL_IMAGE_BASE = '/wp-content/themes/jw-zw/assets/images/img-gioi-thieu-benh-vien/';

const DOCTOR_PROFILES = {
	'profile-bstudung': {
		image: `${HOSPITAL_IMAGE_BASE}profile-bs-tu-dung-v2-pc.webp`,
		mobileImage: `${HOSPITAL_IMAGE_BASE}profile-bs-tu-dung-v2-mb.webp`,
		mobileTitle: 'Kinh nghiệm : 25 năm',
		mobileContent: `
			<p><span>∆</span><strong> Chuyên môn:</strong> Phẫu thuật ngoại khoa, tạo hình thẩm mỹ</p>
			<p>- Thư ký quốc gia Hội Tạo hình mũi Châu Á RSA</p>
			<p>- Thành viên Hội Tạo hình Thẩm mỹ Quốc tế ISAPS</p>
			<p>- Thành viên Hội Tạo hình Thẩm mỹ Việt Nam VSAPS</p>
			<p>- Bác sĩ Việt Nam đầu tiên tham gia điều hành phiên Chủ tịch PRS Hàn Quốc</p>
			<p>- Bác sĩ Việt Nam đầu tiên tham gia biên soạn sách Phẫu thuật Tạo hình đầu mặt Facial Aesthetic Surgery tại Hoa Kỳ</p>
			<p><span>∆</span><strong> Nghiên cứu khoa học:</strong> Báo cáo nghiên cứu khoa học tại Hội nghị PRS Hàn Quốc, TSAPS Đài Loan, Miami Mỹ, ISAPS...</p>
			<p><span>∆</span><strong> Thành tựu:</strong></p>
			<p>- Đạt Huân chương Lao động hạng Ba</p>
			<p>- Đạt Giải Á quân Hiệp hội Nội khoa Hoa Kỳ ACOI</p>
			<p>- Đạt Cúp vàng Thành tựu Y khoa Việt Nam 2020</p>
			<p>- Bằng khen vinh danh của Thủ tướng Chính phủ</p>
			<p>- Hai bằng khen vinh danh của Bộ trưởng Bộ Y tế</p>
			<p>- Bằng khen của Bộ trưởng Bộ Giáo dục và Đào tạo</p>
			<p>- Bằng khen từ Hội Khuyến học, Học bổng Vừ A Dính</p>
			<p>- Bộ Y tế tặng Kỷ niệm chương Vì sức khỏe Nhân dân</p>
			<p>- Hai bằng khen từ Chủ tịch Ủy ban Nhân dân TP.HCM</p>
			<p>- Bằng khen của Ủy ban Mặt trận Tổ quốc Việt Nam TP. Đà Nẵng</p>
		`,
	},
	'profile-bsnguyenthienhieu': {
		image: `${HOSPITAL_IMAGE_BASE}profile-bs-le-thien-hieu-v2-pc.webp`,
		mobileImage: `${HOSPITAL_IMAGE_BASE}profile-bs-le-thien-hieu-v2-mb.webp`,
		mobileTitle: 'Kinh nghiệm: 15 năm',
		mobileContent: `
			<p><span>∆</span><strong> Chuyên môn:</strong> Thẩm mỹ mũi, mắt</p>
			<p><span>∆</span><strong> Đào tạo:</strong></p>
			<p>- Tốt nghiệp Đại học Y Dược TP.HCM</p>
			<p>- Tốt nghiệp chuyên khoa tạo hình thẩm mỹ Đại học Y Hà Nội</p>
			<p>- Thạc sĩ chuyên ngành phẫu thuật ngoại khoa - Đại học Y Dược TP.HCM</p>
			<p>- Thành viên của Hiệp hội tạo hình thẩm mỹ Hàn Quốc</p>
			<p><span>∆</span><strong> Bằng cấp:</strong></p>
			<p>- Chứng chỉ khóa học: Phẫu thuật tạo hình thẩm mỹ vùng đầu mặt cổ</p>
			<p>- Chứng chỉ đào tạo: Kiểm soát nhiễm khuẩn</p>
			<p>- Chứng nhận tham dự hội thảo khoa học thẩm mỹ: Vì sự hoàn hảo của nét đẹp Phương Đông</p>
			<p>- Chứng nhận tham dự hội nghị: Motiva Implants - Xu hướng mới trong nâng ngực thẩm mỹ</p>
			<p>- Chứng chỉ Cập nhật kiến thức tạo hình thẩm mỹ</p>
			<p>- Chứng chỉ Phẫu thuật tạo hình thẩm mỹ mũi cấu trúc nâng cao 2023</p>
		`,
	},
	'profile-bsmankoonsuh': {
		image: `${DOCTOR_IMAGE_BASE}profile-bs-man-koon-suh-pc.webp`,
		mobileImage: `${DOCTOR_IMAGE_BASE}profile-bs-man-koon-suh-mb.webp`,
		mobileTitle: 'CÔNG TÁC CHUYÊN MÔN',
		mobileContent: `
			<p>- Giám đốc Hệ thống JW toàn cầu</p>
			<p>- Giám đốc nghiên cứu viện phục hồi Đại học Y Yonsei</p>
			<p>- Giám đốc học thuật Hội nghiên cứu phẫu thuật mũi Hiệp hội phẫu thuật tạo hình Hàn Quốc</p>
			<p>- Giảng viên trường Đại học Y Yeonsei</p>
			<p>- Ủy viên thẩm định báo Hiệp hội phẫu thuật thẩm mỹ Hàn Quốc.</p>
			<p>- Hội viên Hiệp hội chỉnh hình Hàn Quốc</p>
			<p>- Hội viên chính thức Hiệp hội phẫu thuật tạo hình Quốc Tế.</p>
			<p>- Thành viên Viện nghiên cứu phục chế mô cơ con người thuộc Trường Đại học Y Yonsei.</p>
			<p>- Ấn phẩm đã xuất bản:</p>
			<p>Sách "Phẫu thuật mũi Châu Á (Asisan rhinoplasty)</p>
			<p>Nghiên cứu và phát triển cho ngành nâng mũi hiện đại của Châu Á</p>
		`,
		modalColor: 'update',
	},
	'profile-bschulhwanseul': {
		image: `${DOCTOR_IMAGE_BASE}profile-bs-schul-hwan-seul-pc.webp`,
		mobileImage: `${DOCTOR_IMAGE_BASE}profile-bs-schul-hwan-seul-mb.webp`,
		mobileTitle: 'CÔNG TÁC CHUYÊN MÔN',
		mobileContent: `
			<p>- Chủ tịch Hội nghiên cứu phẫu thuật ngực</p>
			<p>- Hiệp hội Phẫu thuật tạo hình Hàn Quốc</p>
			<p>- Giáo sư phẫu thuật tạo hình tại Đại học Severance Yeong Dong</p>
			<p>- Ủy viên khảo thí Hiệp hội phẫu thuật tạo hình Hàn Quốc</p>
			<p>- Chuyên gia phẫu thuật tạo hình tại Bệnh viện Severance</p>
			<p>- Chuyên gia thẩm mỹ tạo hình tại JW Hàn Quốc</p>
			<p>- Hội viên chính thức Hiệp hội phẫu thuật tạo hình Quốc tế</p>
			<p>- Hội viên chính thức Hiệp hội phẫu thuật thẩm mỹ Hàn Quốc</p>
			<p>- Hội viên chính thức Hiệp hội phẫu thuật tay Hàn Quốc</p>
			<p>- Hội viên chính thức Hiệp hội tạo hình phẫu thuật xương mặt Hàn Quốc</p>
		`,
		modalColor: 'update',
	},
	'profile-bshonglimchoi': {
		image: `${DOCTOR_IMAGE_BASE}profile-bs-hong-lim-choi-pc.webp`,
		mobileImage: `${DOCTOR_IMAGE_BASE}profile-bs-hong-lim-choi-mb.webp`,
		mobileTitle: 'CÔNG TÁC CHUYÊN MÔN',
		mobileContent: `
			<p>- Tốt nghiệp Đại học y Yonsei Hàn Quốc</p>
			<p>- Nhận học vị Tiến sĩ Y học tại Đại học y Yonsei Hàn Quốc</p>
			<p>- Nhận bằng đào tạo Phẫu thuật Thẩm mỹ tại Đại học New York</p>
			<p>- Giám đốc Hiệp hội thẩm mỹ Hàn Quốc</p>
			<p>- Giám đốc học thuật Câu lạc bộ nghiên cứu phẫu thuật mắt của Hiệp hội Thẩm mỹ mắt Hàn Quốc</p>
			<p>- Thành viên chính thức của Hiệp hội Thẩm mỹ mắt Hàn Quốc</p>
			<p>- Chuyên gia phẫu thuật thẩm mỹ mắt tại Bệnh viện Thẩm mỹ JW Hàn Quốc</p>
			<p>- Chuyên gia chỉnh hình, tái phẫu thuật mắt hỏng - Bệnh viện Thẩm mỹ JW Hàn Quốc</p>
			<p>- Hội viên chính thức Hiệp hội chỉnh hình Hàn Quốc</p>
			<p>- Hội viên chính thức Hiệp hội sắc đẹp Nhật Bản</p>
			<p>- Hội viên chính thức Hiệp hội chỉnh hình Quốc tế</p>
			<p>- Cùng TS.BS Nguyễn Phan Tú Dung đồng sáng lập Trung tâm Tái phẫu thuật mắt đầu tiên tại Việt Nam</p>
		`,
		modalColor: 'update',
	},
	'profile-bsnguyenthihongloan': {
		image: `${HOSPITAL_IMAGE_BASE}profile-bs-nguyen-thi-hong-loan-v2-pc.webp`,
		mobileImage: `${HOSPITAL_IMAGE_BASE}profile-bs-nguyen-thi-hong-loan-v2-mb.webp`,
		mobileTitle: 'Kinh nghiệm : 9 năm',
		mobileContent: `
			<p><span>&#8710;</span><strong> Chuyên môn:</strong> Điều trị da liễu, thẩm mỹ da</p>
			<p><span>&#8710;</span><strong> Đào tạo:</strong></p>
			<p>- Tốt nghiệp CKI chuyên ngành Da Liễu ĐH Y Dược TP. HCM</p>
			<p><span>&#8710;</span><strong> Bằng cấp:</strong></p>
			<p>- Chứng chỉ khóa đào tạo Da liễu - Thẩm mỹ nội khoa (Hàn Quốc, Singapore, Thái Lan)</p>
			<p>- Chứng chỉ Ứng dụng Laser và ánh sáng trong da liễu</p>
			<p>- Chứng chỉ Kỹ thuật tiêm Botulinum Toxin trong thẩm mỹ</p>
			<p>- Chứng chỉ Kỹ thuật tiêm chất làm đầy trong thẩm mỹ</p>
			<p>- Chứng chỉ đào tạo Điều trị da liễu - Thẩm mỹ da</p>
			<p>- Chứng chỉ đào tạo Phương pháp kết hợp đa dạng chất làm đầy và căng chỉ trong tạo hình đường nét khuôn mặt</p>
			<p>- Chứng chỉ đào tạo Phòng ngừa và phục hồi tổn thương da sau thẩm mỹ điều trị da</p>
		`,
	},
	'profile-bsdaohaiyen': {
		image: `${HOSPITAL_IMAGE_BASE}profile-bs-dao-hai-yen-v2-pc.webp`,
		mobileImage: `${HOSPITAL_IMAGE_BASE}profile-bs-dao-hai-yen-v2-mb.webp`,
		mobileTitle: 'Kinh nghiệm: 10 năm',
		mobileContent: `
			<p><span>∆</span><strong> Chuyên môn:</strong> Điều trị da liễu, thẩm mỹ da</p>
			<p><span>∆</span><strong> Đào tạo:</strong></p>
			<p>- Tốt nghiệp Top 10 Thủ khoa Đại học Bác sĩ Y đa khoa ĐH Y Dược TP. HCM</p>
			<p>- Thủ khoa CKI chuyên ngành Da liễu ĐH Y khoa Phạm Ngọc Thạch</p>
			<p><span>∆</span><strong> Bằng cấp:</strong></p>
			<p>- Chứng chỉ khóa đào tạo Da liễu - Thẩm mỹ nội khoa (Hàn Quốc, Singapore, Thái Lan)</p>
			<p>- Chứng chỉ khoá đào tạo Da liễu-Thẩm mỹ nội khoa Việt Nam</p>
			<p>- Chứng chỉ đào tạo Thủ thuật cơ bản và tiểu phẫu da</p>
			<p>- Chứng chỉ đào tạo sử dụng kỹ thuật Laser trong xử trí tổn thương mạch máu, sắc tố da và sẹo</p>
			<p>- Chứng chỉ đào tạo y khoa liên tục các điều trị mới, công nghệ mới trong điều trị da liễu,thẩm mỹ da,thẩm mỹ nội khoa</p>
			<p>- Chứng chỉ: Đào tạo sử dụng liệu pháp Exosome trong điều trị da liễu - thẩm mỹ da</p>
		`,
	},
	'profile-bshongloan': {
		image: `${HOSPITAL_IMAGE_BASE}profile-bs-nguyen-thi-hong-loan-v2-pc.webp`,
		mobileImage: `${HOSPITAL_IMAGE_BASE}profile-bs-nguyen-thi-hong-loan-v2-mb.webp`,
		mobileTitle: 'Kinh nghiệm: 9 năm',
		mobileContent: `
			<p><span>∆</span><strong> Chuyên môn:</strong> Điều trị da liễu, thẩm mỹ da</p>
			<p><span>∆</span><strong> Đào tạo:</strong></p>
			<p>- Tốt nghiệp CKI chuyên ngành Da Liễu ĐH Y Dược TP. HCM</p>
			<p><span>∆</span><strong> Bằng cấp:</strong></p>
			<p>- Chứng chỉ khóa đào tạo Da liễu - Thẩm mỹ nội khoa (Hàn Quốc, Singapore, Thái Lan)</p>
			<p>- Chứng chỉ Ứng dụng Laser và ánh sáng trong da liễu</p>
			<p>- Chứng chỉ Kỹ thuật tiêm Botulinum Toxin trong thẩm mỹ</p>
			<p>- Chứng chỉ Kỹ thuật tiêm chất làm đầy trong thẩm mỹ</p>
			<p>- Chứng chỉ đào tạo Điều trị da liễu - Thẩm mỹ da</p>
			<p>- Chứng chỉ đào tạo Phương pháp kết hợp đa dạng chất làm đầy và căng chỉ trong tạo hình đường nét khuôn mặt</p>
			<p>- Chứng chỉ đào tạo Phòng ngừa và phục hồi tổn thương da sau thẩm mỹ điều trị da</p>
		`,
	},
};

export default class DoctorProfileModalController {
	constructor() {
		this.initialized = false;
		this.activeTabClass = 'active_mb';
		this.tabButtonSelector = '.tablinks[data-doctor-tab-target]';
		this.tabContentSelector = '.tabcontent';
		this.profileTriggerSelector = '.tabcontent-thammy-content-buttom[data-info]';
		this.closeModal = this.closeModal.bind(this);
		this.handleWindowClick = this.handleWindowClick.bind(this);
	}

	init() {
		if (this.initialized) {
			return;
		}

		this.initialized = true;
		this.modal = document.getElementById('myCustomModal');
		this.modalBody = document.getElementById('modal-body-content');
		this.closeButton = this.modal?.querySelector('.close-profile') || null;
		this.bindTabButtons();
		this.activateDefaultTab();
		this.bindProfileTriggers();
		this.bindModalClose();
	}

	bindTabButtons() {
		document.querySelectorAll(this.tabButtonSelector).forEach((button) => {
			button.addEventListener('click', (event) => {
				this.activateTab(button.dataset.doctorTabTarget, event.currentTarget);
			});
		});
	}

	activateDefaultTab() {
		const defaultButton = document.querySelector(`${this.tabButtonSelector}[data-default-doctor-tab="true"]`)
			|| document.querySelector(this.tabButtonSelector);

		if (!defaultButton) {
			return;
		}

		this.activateTab(defaultButton.dataset.doctorTabTarget, defaultButton);
	}

	activateTab(targetId, triggerButton) {
		if (!targetId || !(triggerButton instanceof HTMLElement)) {
			return;
		}

		document.querySelectorAll(this.tabContentSelector).forEach((content) => {
			content.style.display = 'none';
		});

		document.querySelectorAll(this.tabButtonSelector).forEach((button) => {
			button.classList.remove(this.activeTabClass);
		});

		const targetContent = document.getElementById(targetId);
		if (!targetContent) {
			return;
		}

		targetContent.style.display = 'block';
		triggerButton.classList.add(this.activeTabClass);
	}

	bindProfileTriggers() {
		document.body.addEventListener('click', (event) => {
			const trigger = event.target.closest(this.profileTriggerSelector);
			if (!trigger) {
				return;
			}

			this.openProfile(trigger.dataset.info || '');
		});
	}

	openProfile(profileKey) {
		if (!this.modal || !this.modalBody || !profileKey) {
			return;
		}

		const profile = DOCTOR_PROFILES[profileKey];
		if (!profile) {
			return;
		}

		if (profile.modalColor) {
			this.modal.setAttribute('data-color', profile.modalColor);
		} else {
			this.modal.removeAttribute('data-color');
		}

		const isMobile = window.innerWidth <= 490;
		const selectedImage = isMobile ? profile.mobileImage : profile.image;
		const selectedTitle = isMobile ? profile.mobileTitle || '' : '';
		const selectedContent = isMobile ? profile.mobileContent || '' : '';

		this.modalBody.innerHTML = `
			<img src="${selectedImage}" alt="Bác sĩ" style="width: 100%;">
			<div class="profile-content-mb">
				<div class="profile-mb-block"></div>
				<h2>${selectedTitle}</h2>
				<div>${selectedContent}</div>
			</div>
		`;
		this.modal.style.display = 'block';
	}

	bindModalClose() {
		if (this.closeButton) {
			this.closeButton.addEventListener('click', this.closeModal);
		}

		if (this.modal) {
			window.addEventListener('click', this.handleWindowClick);
		}
	}

	handleWindowClick(event) {
		if (event.target === this.modal) {
			this.closeModal();
		}
	}

	closeModal() {
		if (this.modal) {
			this.modal.style.display = 'none';
		}
	}
}
